<template>
  <div>
    <vs-button class="mb-2 mt-2" size="sm" type="line" color="primary" icon="event" @click="open">Eventos</vs-button>
    <vs-popup style="z-index: 5000 !important;" title="Eventos de proyecto" fullscreen :active.sync="showDialog">
      <div v-if="requestMade">
        <vs-tabs alignment="fixed" class="tab-action-btn-fill-container">
          <!-- TAB NUEVO EVENTO -->
          <vs-tab label="Nuevo evento">
            <div class="tab-text">
              <label class="italic mb-5">Campos requeridos (<span style="color:red">*</span>)</label>
              <div class="skinny row">
                <div class="col-xs-12 col-md-6">
                  <div v-if="dataResponse.projects.length > 1">
                    <label class="bold"><span style="color:red">*</span> Deja marcados solo los proyectos a los cuales se les asignará el evento:</label>
                    <div class="centerx">
                      <vs-col v-for="(project, index) in dataResponse.projects" :key="index">
                        <vs-checkbox v-model="projectsSelected" color="success" class="mb-2" :vs-value="project.project_id" >{{ project.alias }} (PID: {{ project.project_id }})</vs-checkbox>
                      </vs-col>
                    </div>
                  </div>
                  <label class="bold mt-3"><span style="color:red">*</span> Eventos de proyecto:</label>
                  <vs-select
                    class="w-full"
                    @input="setEventSelected"
                    v-model.lazy="eventSelected"
                    name="eventSelected"
                    placeholder="Seleccione una opción">
                    
                    <vs-select-item
                    :key="index"
                    :value="index"
                    :text="item.event"
                    v-for="(item,index) in dataResponse.projectEventsLog"
                    class="w-full"
                    />
                  </vs-select>

                  <div class="skinny row mb-5 mt-5">
                    <div v-if="dateNeeded" class="col-xs-12 col-md-4">
                      <label class="bold"><span style="color:red">*</span> Fecha</label>
                      <datepicker
                        placeholder="Fecha"
                        :language="es"
                        v-model="dateForEvent"
                        format="dd/MM/yyyy"
                        />
                    </div>

                    <div v-if="amountNeeded" class="col-xs-12 col-md-4">
                    <label class="bold"><span style="color:red">*</span> Cantidad</label>
                      <vs-input class="w-full" type="number" v-model="amountForEvent"/>
                    </div>

                    <div v-if="contactNeeded" class="col-xs-12 col-md-4">
                    <label class="bold"><span style="color:red">*</span> Medios de contacto:</label>
                      <vs-select
                        class="w-full"
                        v-model.lazy="contactForEvent"
                        name="contactForEvent"
                        placeholder="Seleccione una opción"
                        >
                        <vs-select-item
                          :key="index"
                          :value="index"
                          :text="item"
                          v-for="(item,index) in contactTypes"
                          class="w-full"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <label class="bold"><span style="color:red">*</span> Vista previa del evento del proyecto:</label>
                  <vx-textarea v-model="currentEvent" height="200px"/>
                    <div class="flex flex-wrap mb-4">
                      <div class="centerx">
                          <vs-checkbox v-model="sendEmail" color="success" class="mb-2" >Notificar vía email a los usuarios relacionados al proyecto</vs-checkbox>
                      </div>
                    </div>
                    <div class="flex flex-wrap">
                      <vs-button :disabled="eventSelected == null || projectsSelected.length == 0 || currentEvent == ''" color="#43a047" @click="sendEvent()">Guardar</vs-button>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                  <p class="text-center bold">5 Eventos del proyecto más recientes:</p>
                  <div v-if="dataResponse.projects.length > 1" class="vx-col w-full mb-3">
                    <vs-select class="w-full mb-2"
                      @input="setProjectSelected"
                      label="Selecciona un proyecto para ver sus eventos." 
                      v-model.lazy="selectedProject"
                      name="selectedProject"
                      placeholder="Seleccione una opción" >
                      <vs-select-item :key="index" :value="item.project_id" :text="item.alias" v-for="(item,index) in dataResponse.projects" class="w-full" />
                    </vs-select>
                  </div>
                  <div v-if="timelineDataEvents.length == 0">
                    <vs-alert icon-pack="feather" icon="icon-info" class="h-full mt-2" color="primary">
                      <span>Este proyecto no cuenta con eventos.</span>
                    </vs-alert>
                  </div>
                  <div v-else>
                    <vs-table
                      ref="table"
                      stripe
                      :data="timelineDataEvents"
                      noDataText="No hay datos disponibles"
                    >
                      <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                          <vs-td><small><strong>{{compactDateFormat(tr.created_at)}}</strong>-{{tr.event}}</small></vs-td>
                          <vs-td>
                            <vs-button
                            radius
                            :disabled="!tr.can_be_deleted"
                            color="danger"
                            type="filled"
                            icon-pack="feather"
                            icon="icon-trash"
                            @click="confirmDeleteProjectEvent(tr.id)"
                            ></vs-button>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </div>
            </div>
          </vs-tab>

          <!-- TAB BITACORA DE EVENTOS -->
          <vs-tab label="Bitácora de eventos">
              <div class="tab-text">
                <div class="skinny row">
                  <div class="w-full">
                    <md-card>
                      <md-card-content>
                        <div v-if="dataResponse.projects.length > 1">
                          <vs-select class="w-full mb-2"
                            label="Selecciona un proyecto para ver sus eventos." 
                            @input="getAllEventsForProject()"
                            v-model.lazy="selectedProjectEventHistory"
                            name="selectedProjectEventHistory"
                            placeholder="Seleccione una opción" >
                            <vs-select-item :key="index" :value="item.project_id" :text="item.alias" v-for="(item,index) in dataResponse.projects" class="w-full" />
                          </vs-select>
                        </div>
                        <vs-button v-else color="#303f9f" type="border" class="mb-3" icon-pack="feather" icon="icon-clock" @click="getAllEventsForProject()">Mostrar historial</vs-button>
                        <vs-table
                          :sst="true"
                          ref="table"
                          stripe
                          :max-items="30"
                          :data="allEventsProjectHistory"
                          noDataText="No hay datos disponibles"
                        >
                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                          <div class="pager" v-if="allEventsProjectHistory.length > 0">
                            <div class="flex flex-wrap">
                              <vs-button
                                :disabled="allDataHistory.prev_page_url ? null:true"
                                type="border"
                                radius
                                @click="pager(allDataHistory.prev_page_url)"
                                class="mr-2"
                                icon-pack="feather"
                                icon="icon-chevron-left"
                              ></vs-button>
                              <vs-button
                                v-if="allDataHistory.prev_page_url != null"
                                text-color="#212121"
                                type="flat"
                                radius
                                @click="pager(allDataHistory.first_page_url)"
                                class="rounded-circle mr-2"
                              >
                                <strong>1 ..</strong>
                              </vs-button>
                              <vs-button type="flat" text-color="#303f9f" radius class="mr-2">
                                <strong>{{ allDataHistory.current_page }}</strong>
                              </vs-button>
                              <vs-button
                                v-if="allDataHistory.next_page_url != null"
                                text-color="#212121"
                                type="flat"
                                radius
                                @click="pager(allDataHistory.last_page_url)"
                                class="rounded-circle mr-2"
                              >
                                <strong>.. {{ allDataHistory.last_page }}</strong>
                              </vs-button>
                              <vs-button
                                :disabled="allDataHistory.next_page_url ? null:true"
                                type="border"
                                radius
                                @click="pager(allDataHistory.next_page_url)"
                                class="mr-2"
                                icon-pack="feather"
                                icon="icon-chevron-right"
                              ></vs-button>
                            </div>
                          </div>
                          <!-- ITEMS PER PAGE -->
                          <div
                            v-if="totalRecords > 0"
                            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                          >
                            <span class="mr-2">{{ from }} - {{ to }} de {{ totalRecords }}</span>
                          </div>
                        </div>
                        <template slot="thead">
                          <vs-th>Fecha de creación</vs-th>
                          <vs-th>Evento</vs-th>
                        </template>
                        <template slot-scope="{data}">
                          <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                            <vs-td>{{ compactDateFormat(tr.created_at) }}</vs-td>
                            <vs-td>{{ tr.event }}</vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vs-popup>
  </div>
</template>

<script>
  import dateHelper from "@mixins/dateHelper";
  import formatHelper from "@mixins/formatHelper";
  import Datepicker from "vuejs-datepicker";
  import { es } from "vuejs-datepicker/dist/locale";

export default {
  name: 'project-events',
  props: ['project_id', 'status'],
  mixins: [formatHelper,dateHelper],
  components: {
      Datepicker,
  },
  data() {
      return {
        showDialog: false
        , es: es
        , loading:false,
        eventSelected: null,
        eventsToShow:[],
        projectsSelected:[],
        contactTypes: ["correo electrónico","llamada telefónica","whatsapp"],
        selectedProject: 0,
        selectedProjectEventHistory: 0,
        currentEvent: "",
        eventIdToDelete: -1,
        currentOriginalEvent: "",
        dateNeeded: false,
        amountNeeded: false,
        contactNeeded: false,
        dateForEvent: new Date(),
        amountForEvent: 0,
        contactForEvent: 0,
        timelineDataEvents: [],
        allDataHistory: {
            data: [],
            total: 0,
            from: null,
            to: null,
        },
        dataResponse: {
            events:[],
            projects:[],
            projectEventsLog:[]
        },
        requestMade: false,
        currentMonthName: new Date().toLocaleString('default', { month: 'long' })
        , sendEmail: true
    }
  },
  watch: {
    dateForEvent: function (newDate, oldDate) {
      let event = this.currentOriginalEvent;
      this.currentEvent = event.replace('%date%', this.compactDateFormat(newDate));
      if (this.amountNeeded) {
          this.currentEvent = this.currentEvent.replace('%amount%', this.amountForEvent);                    
      }
      if (this.contactNeeded) {
          this.currentEvent = this.currentEvent.replace('%contact%', this.contactTypes[this.contactForEvent]);                    
      }
    },
    amountForEvent: function (newAmount, oldAmount) {
      let event = this.currentOriginalEvent;
      this.currentEvent = event.replace('%amount%', newAmount);
      if (this.dateNeeded) {
          this.currentEvent = this.currentEvent.replace('%date%', this.compactDateFormat(this.dateForEvent));
      }
      if (this.contactNeeded) {
          this.currentEvent = this.currentEvent.replace('%contact%', this.contactTypes[this.contactForEvent]);                    
      }
    },
    contactForEvent: function (newContact, oldContact) {
      let event = this.currentOriginalEvent;
      this.currentEvent = event.replace('%contact%', this.contactTypes[newContact]);
      if (this.dateNeeded) {
          this.currentEvent = this.currentEvent.replace('%date%', this.compactDateFormat(this.dateForEvent));
      }
      if (this.amountNeeded) {
          this.currentEvent = this.currentEvent.replace('%amount%', this.amountForEvent);                    
      }
    }
  },
  computed:{
    eventsFiltered () {
      return this.eventsToShow;
    },
    allEventsProjectHistory() {
      return this.allDataHistory.data;
    },
    from() {
      return this.allDataHistory.from;
    },
    to() {
      return this.allDataHistory.to;
    },
    totalRecords() {
      return this.allDataHistory.total;
    }
  },
  methods: {
    open(){
      this.getEvents();
      this.showDialog = true;
    },
    async getEvents(){
      this.resetValues();
      this.showLoading(true);
      this.requestMade = false;
      await axios.get(`/api/project/getProjectEventList/${this.project_id}`).then(response => {
          this.dataResponse = response.data;
          this.setProjectsForCheckBoxes();
          this.selectedProject = this.dataResponse.projects[0].project_id;
          if (this.dataResponse.projects.length == 1) {
              this.selectedProjectEventHistory = this.selectedProject;
          }
          this.eventsToShow = this.dataResponse.projectEvents.filter(p => p.project_id == this.selectedProject);
          this.requestMade = true;
      }).catch(error => {
          this.showLoading(false);
          this.requestMade = false;
          if(error.response.data.message != undefined){
              this.errorNotif("Aviso", error.response.data.message, 4000);
          }else{
              this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
          }
      });
      this.setEvents();
      this.requestMade = true;
      this.showLoading(false);
    },
    async getAllEventsForProject(url = `/api/project/getAllEventsForProject/${this.selectedProjectEventHistory}`){
      this.showLoading(true);
      await axios.get(url).then(response => {
        this.allDataHistory = response.data;
      }).catch(error => {
        if(error.response.data.message != undefined){
          this.errorNotif("Aviso", error.response.data.message, 4000);
        }else{
          this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
        }
      });
      this.showLoading(false);
    },
    async sendEvent(){
      if(this.currentEvent){
        this.showLoading(true);
        await axios.post(`/api/project/postProjectEvent/${this.project_id}`, {
          project_ids: this.projectsSelected,
          event: this.currentEvent,
          project_event_id: this.dataResponse.projectEventsLog[this.eventSelected].id,
          action: "save"
          , sentEmail: this.sendEmail
        }).then(response => {
          this.resetValues();
          this.dataResponse = response.data;
          this.setProjectsForCheckBoxes();
          this.successNotif("Aviso", 'Evento guardado exitosamente', 4000);
          this.eventsToShow = this.dataResponse.projectEvents.filter(p => p.project_id == this.selectedProject);
          if (this.dataResponse.projects.length == 1) {
              this.selectedProjectEventHistory = this.selectedProject;
          }
          this.setEvents();
        }).catch(error => {
          this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
        })
        this.showLoading(false);
      }
    },
    confirmDeleteProjectEvent(id){
      this.eventIdToDelete = id;
      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Aviso`,
          text: '¿Estas seguro de querer eliminar el evento para el proyecto seleccionado?',
          acceptText: "Confirmar",
          cancelText: "Cancelar",
          accept: this.deleteEvent
      })
    },
    async deleteEvent(){
      this.showLoading(true);
      await axios.post(`/api/project/postProjectEvent/${this.project_id}`, {
        project_id: this.selectedProject,
        project_event_id: this.eventIdToDelete,
        action: "delete"
      }).then(response => {
        this.resetValues();
        this.dataResponse = response.data;
        this.eventsToShow = this.dataResponse.projectEvents.filter(p => p.project_id == this.selectedProject);
        this.successNotif("Aviso", 'Evento eliminado exitosamente', 4000);
        this.setEvents();
      }).catch(error => {
        this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
      })
      this.showLoading(false);
    },
    setProjectsForCheckBoxes(){
      this.projectsSelected = [];
      Object.keys(this.dataResponse.projects).forEach(key => {
        const project = this.dataResponse.projects[key];
        this.projectsSelected.push(project.project_id);  
      })
    },
    setEvents(){
      this.timelineDataEvents = [];
      Object.keys(this.eventsFiltered).forEach(key => {
        const event = this.eventsFiltered[key];
        this.timelineDataEvents.push(event);  
      })
    },
    async pager(url) {
      await this.getAllEventsForProject(url);
    },
    setProjectSelected() {
      this.eventsToShow = this.dataResponse.projectEvents.filter(p => p.project_id == this.selectedProject);
      this.setEvents();                 
    },
    setEventSelected(){
      this.dateForEvent = new Date();
      this.amountForEvent = 0;
      this.contactForEvent = 0;
      let event = this.dataResponse.projectEventsLog[this.eventSelected];
      this.currentEvent = event.event;
      this.currentOriginalEvent = event.event;
      this.dateNeeded = event.need_date;
      this.amountNeeded = event.need_amount;
      this.contactNeeded = event.need_contact;
    },
    resetValues(){
      this.allDataHistory.data = [];
      this.allDataHistory.total = 0;
      this.allDataHistory.from = null;
      this.allDataHistory.to = null;
      this.eventSelected= null;
      this.eventIdToDelete = -1;
      this.currentEvent = "";
      this.currentOriginalEvent = "";
      this.amountNeeded= false;
      this.dateNeeded= false;
      this.contactNeeded= false;
      this.dateForEvent= new Date();
      this.amountForEvent= 0;
      this.contactForEvent = 0;
      this.sendEmail = true;
    }
  }
}
</script>

<style>

</style>